import { render, staticRenderFns } from "./SyllablesTutorialContainer.vue?vue&type=template&id=21630547&scoped=true"
import script from "./SyllablesTutorialContainer.vue?vue&type=script&lang=ts"
export * from "./SyllablesTutorialContainer.vue?vue&type=script&lang=ts"
import style0 from "./SyllablesTutorialContainer.vue?vue&type=style&index=0&id=21630547&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21630547",
  null
  
)

export default component.exports